import React from "react";
import { userDeatils } from "../../RactiveVariables";
import { useReactiveVar } from "@apollo/client";
import { Link } from "react-router-dom";

export default function AccessDenied() {
    const user = useReactiveVar(userDeatils);
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            backgroundColor: '#f8f9fa',
            margin: '-20px',
            padding: '20px'
        }}>
            <div className="text-center">
                <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>Access Denied!</h1>
                <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>Please contact your admin</p>
                <Link 
                    to={user?.data?.loginType && user?.data?.loginType.toLowerCase()==="admin" ? "/users" : "/schooluser"}
                    style={{
                        display: 'inline-block',
                        padding: '10px 20px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '5px',
                        fontSize: '1rem'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                >
                    Back to user list
                </Link>
            </div>
        </div>
    )
}